export const isWindows = () => navigator.userAgent.indexOf('Windows') !== -1;